angular.module('impactx.login').controller('LoginSamlErrorCtrl', [
    '$mdDialog',
    LoginSamlErrorController]);

function LoginSamlErrorController($mdDialog) {
    $mdDialog.show({
        templateUrl: 'modules/login/templates/login.sso.error.tmpl.html',
        controller: 'LoginSamlErrorDialogCtrl',
        controllerAs: "loginSamlErrorDialogCtrl",
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: false
    });
}